// 📁 redux/slices/seaFreight.js (version complète avec extensions pour import Excel)

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  success: null,
  seaFreights: [],
  seaFreight: null,
  summary: null,
  confirmResult: null
};

const slice = createSlice({
  name: 'seaFreight',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // HAS SUCCESS
    hasSuccess(state, action) {
      state.isLoading = false;
      state.success = action.payload;
    },

    // GET SEA FREIGHTS
    getSeaFreightsSuccess(state, action) {
      state.isLoading = false;
      state.seaFreights = action.payload;
    },

    // GET SEA FREIGHT
    getSeaFreightSuccess(state, action) {
      state.isLoading = false;
      state.seaFreight = action.payload;
    },

    // SET IMPORT SUMMARY
    setSummary(state, action) {
      state.isLoading = false;
      state.summary = action.payload;
    },

    // SET CONFIRM RESULT
    setConfirmResult(state, action) {
      state.isLoading = false;
      state.confirmResult = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getSeaFreights() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/seaFreights/getAllSeaFreights');
      dispatch(slice.actions.getSeaFreightsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getSeaFreight(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/seaFreights/getOneSeaFreight/${id}`);
      dispatch(slice.actions.getSeaFreightSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function startLoading() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
  }
}

// ----------------------------------------------------------------------

export const importSeaFreight = createAsyncThunk(
  'seaFreight/importSeaFreight',
  async ({ formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post('/api/seaFreightImport', formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export function confirmSeaFreightImport({ data, originCountryId, destinationCountryId, portsToCreate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post('/api/seaFreightImport/confirm', {
        data,
        originCountryId,
        destinationCountryId,
        portsToCreate
      });
      dispatch(slice.actions.setConfirmResult(response.data));
      return { payload: response.data }; // ✅ ici on retourne bien un payload
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return { error }; // pour pouvoir catch côté composant
    }
  };
}

export const rollbackSeaFreightImport = createAsyncThunk(
  'seaFreight/rollbackSeaFreightImport',
  async (importBatch, { rejectWithValue }) => {
    try {
      const res = await axios.post(`/api/seaFreightImport/rollback/${importBatch}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Erreur rollback');
    }
  }
);

export const fetchSeaFreightBatches = createAsyncThunk(
  'seaFreight/fetchSeaFreightBatches',
  async (_, { rejectWithValue }) => {
    try {
      const res = await axios.get('/api/seaFreightImport/batches');
      return res.data;
    } catch (err) {
      return rejectWithValue('Error while fetching import batches.');
    }
  }
);

export const deleteSeaFreightImportBatch = createAsyncThunk(
  'seaFreight/deleteSeaFreightImportBatch',
  async (importBatch, { rejectWithValue }) => {
    try {
      const res = await axios.delete(`/api/seaFreightImport/batches/${importBatch}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || 'Error while deleting import batch.');
    }
  }
);

